import { Box } from "../Box";
import { Collapse, CollapseContent } from "../Collapse";
import { Text } from "../Text/Text";
import React from 'react';
export function InlineError(_ref) {
  var error = _ref.error,
      errorVariant = _ref.errorVariant;
  return /*#__PURE__*/React.createElement(Collapse, {
    isShowing: Boolean(error) && errorVariant === 'inline'
  }, /*#__PURE__*/React.createElement(CollapseContent, null, /*#__PURE__*/React.createElement(Box, {
    paddingY: 4,
    paddingX: "px"
  }, typeof error === 'string' ? /*#__PURE__*/React.createElement(Text, {
    variant: "caption",
    color: "alertError"
  }, error) : error)));
}